import axiosInstance from "core/api/axiosInstance";
import { consolidateParking, parkingStats } from "../parking/model/parkingModel";

const findValue = (value, key, depth = 0) => {
  if (!value || typeof value !== "object" || depth > 8) return undefined;
  if (Object.prototype.hasOwnProperty.call(value, key)) return value[key];
  for (const child of Object.values(value)) {
    const result = findValue(child, key, depth + 1);
    if (result !== undefined) return result;
  }
  return undefined;
};
const terminalRows = (value, depth = 0) => {
  if (Array.isArray(value)) return value;
  if (!value || typeof value !== "object" || depth > 8) return null;
  if (value.data != null) return terminalRows(value.data, depth + 1);
  const records = Object.values(value);
  return records.length && records.every((item) => item && typeof item.comercio === "string")
    ? records
    : null;
};
const request = async (url) => {
  if (!localStorage.getItem("token"))
    throw new Error("No hay token de autenticación. Por favor inicie sesión.");
  const { data } = await axiosInstance.get(url);
  let envelope = data;
  for (
    let depth = 0;
    depth < 8 && envelope && typeof envelope === "object" && !Array.isArray(envelope);
    depth++
  ) {
    if (envelope.success === false || (envelope.code != null && Number(envelope.code) !== 0))
      throw new Error(envelope.message || envelope.msm || "No se pudo completar la consulta");
    envelope = envelope.data;
  }
  return data;
};
const failure = (error) => {
  if (error.response?.status === 401) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setTimeout(() => {
      if (window.location.pathname !== "/auth/login") window.location.href = "/auth/login";
    }, 2000);
  }
  return {
    success: false,
    error:
      error.response?.data?.message ||
      error.response?.data?.msm ||
      error.message ||
      "No se pudieron cargar los datos",
    data: [],
  };
};
export const getCommerceDataService = async () => {
  try {
    const rawResponse = await request("/api/dashboard/get-data/comercios");
    const data = terminalRows(rawResponse);
    if (!data || data.some((item) => !item || typeof item.comercio !== "string"))
      throw new Error("El formato de terminales no es válido");
    return { success: true, data, rawResponse };
  } catch (error) {
    return failure(error);
  }
};
export const getCommerceReportService = async () => {
  try {
    const rawResponse = await request("/api/automatization/report/commerces");
    const report = findValue(rawResponse, "report_commerce");
    if (!Array.isArray(report) || report.some((item) => !item || typeof item.comercio !== "string"))
      throw new Error("El formato del reporte de ciclos no es válido");
    const totals = {};
    [
      "total_commerce_no_cycles",
      "total_commerce_open_cycles",
      "total_open_cycles",
      "total_open_cycles_hardware",
      "total_open_cycles_integration",
    ].forEach((key) => {
      const value = findValue(rawResponse, key);
      if (value != null && Number.isFinite(Number(value))) totals[key] = Number(value);
    });
    return { success: true, data: { report_commerce: report, ...totals }, rawResponse };
  } catch (error) {
    return failure(error);
  }
};
export const getConsolidatedParkingData = async () => {
  const [terminals, report] = await Promise.all([
    getCommerceDataService(),
    getCommerceReportService(),
  ]);
  if (!terminals.success) return terminals;
  const data = consolidateParking(
    terminals.data,
    report.success ? report.data.report_commerce : []
  );
  return {
    success: true,
    data,
    stats: parkingStats(data),
    reportTotals: report.success
      ? Object.fromEntries(Object.entries(report.data).filter(([key]) => key !== "report_commerce"))
      : null,
    warning: report.success
      ? null
      : `No se pudo cargar el reporte de ciclos: ${report.error}. Se muestran las terminales; los ciclos sin respuesta aparecen como “Sin datos”.`,
  };
};
export default { getCommerceDataService, getCommerceReportService, getConsolidatedParkingData };
